/* eslint-disable import/no-anonymous-default-export */
import { Component } from 'react'
import { connect } from 'react-redux'
import * as actionCreators from '@/store/user/actionCreators'
import User from '@/modules/user'
export default (WrappedComponent) => {
  class UserModule extends Component {
    constructor() {
      super()
      this.state = { user: null }
    }
    componentWillMount() {
      const user = new User()
      this.setState({ user })
    }
    render() {
      return (
        <WrappedComponent
          user={this.state.user}
          {...this.props}
        />
      )
    }
  }
  // 把store中的数据映射到组件的props
  const mapStateToProps = (state) => ({
    loginStatu: state.getIn(['user', 'loginStatu'])
  })
  // 把store的Dispatch映射到组件的props
  const mapDispatchToProps = (dispatch) => ({
    setStatu(statu) {
      const action = actionCreators.setStatu(statu)
      dispatch(action)
    }
  })
  return connect(mapStateToProps, mapDispatchToProps)(UserModule)
}
